/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_L3Inputs */

const en_mk_sec_pg_l3 = /** @type {(inputs: Mk_Sec_Pg_L3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audit trail of sensitive actions`)
};

const id_mk_sec_pg_l3 = /** @type {(inputs: Mk_Sec_Pg_L3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catatan audit aksi sensitif`)
};

/**
* | output |
* | --- |
* | "Audit trail of sensitive actions" |
*
* @param {Mk_Sec_Pg_L3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_l3 = /** @type {((inputs?: Mk_Sec_Pg_L3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_L3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_l3(inputs)
	return en_mk_sec_pg_l3(inputs)
});